import { call, delay, put } from 'redux-saga/effects';
import { DashboardService } from '../../../services/Dashboard';
import {
  loadBilledByDayFailure,
  loadBilledByDaySuccess,
  loadBilledByMonthFailure,
  loadBilledByMonthSuccess,
  loadDuplicatesByDayFailure,
  loadDuplicatesByDaySuccess,
  loadDuplicatesFailure,
  loadDuplicatesSuccess,
  loadOpenOrderStatusBySkuFailure,
  loadOpenOrderStatusBySkuSuccess,
  loadOpenOrderStatusFailure,
  loadOpenOrderStatusSuccess,
  loadPaidByMonthFailure,
  loadPaidByMonthSuccess
} from './actions';
import {
  IBilledByDayData,
  IBilledMonthData,
  IDuplicateData,
  IDuplicatesByDayData,
  IOpenOrderStatusData,
  IOpenOrderStatusDataBySku,
  IPaidByMonthData,
  Types
} from './types';
import moment from 'moment';
import { ECustomerTypeView } from '../user/types';

interface ILoadDashboardParams {
  payload: {
    selectedCustomerId: string;
    customerType: ECustomerTypeView;
    billedByDayMonthDate: moment.Moment;
    duplicatesByDayMonthDate: moment.Moment;
  };
  type: Types;
}

export function* loadOpenOrderStatusSaga(params: ILoadDashboardParams) {
  const { selectedCustomerId, customerType } = params.payload;
  try {
    const dashboardSvc = new DashboardService();
    const openOrderStatus: IOpenOrderStatusData[] = yield call(
      dashboardSvc.loadOpenOrderStatus.bind(
        dashboardSvc,
        selectedCustomerId,
        customerType
      )
    );
    yield put(loadOpenOrderStatusSuccess(openOrderStatus, moment()));
  } catch (err) {
    console.error('loadDuplicatesSaga', err);
    yield put(loadOpenOrderStatusFailure(err));
  }
}

export function* loadOpenOrderStatusBySkuSaga(params: ILoadDashboardParams) {
  const { selectedCustomerId, customerType } = params.payload;
  try {
    const dashboardSvc = new DashboardService();
    const openOrderStatusBySku: IOpenOrderStatusDataBySku[] = yield call(
      dashboardSvc.loadOpenOrderStatusBySku.bind(
        dashboardSvc,
        selectedCustomerId,
        customerType
      )
    );
    yield put(loadOpenOrderStatusBySkuSuccess(openOrderStatusBySku, moment()));
  } catch (err) {
    console.error('loadDuplicatesSaga', err);
    yield put(loadOpenOrderStatusBySkuFailure(err));
  }
}

export function* loadBilledByMonthSaga(params: ILoadDashboardParams) {
  const { selectedCustomerId, customerType } = params.payload;
  try {
    const dashboardSvc = new DashboardService();
    const billedMonthData: IBilledMonthData[] = yield call(
      dashboardSvc.loadBilledByMonth.bind(
        dashboardSvc,
        selectedCustomerId,
        customerType
      )
    );
    yield put(loadBilledByMonthSuccess(billedMonthData));
  } catch (err) {
    console.error('loadBilledByMonthSaga', err);
    yield put(loadBilledByMonthFailure(err));
  }
}

export function* loadPaidByMonthSaga(params: ILoadDashboardParams) {
  const { selectedCustomerId, customerType } = params.payload;
  try {
    const dashboardSvc = new DashboardService();
    const paidMonthData: IPaidByMonthData[] = yield call(
      dashboardSvc.loadPaidByMonth.bind(
        dashboardSvc,
        selectedCustomerId,
        customerType
      )
    );
    yield put(loadPaidByMonthSuccess(paidMonthData));
  } catch (err) {
    console.error('loadPaidByMonthSaga', err);
    yield put(loadPaidByMonthFailure(err));
  }
}

export function* loadDuplicatesSaga(params: ILoadDashboardParams) {
  const { selectedCustomerId, customerType } = params.payload;
  try {
    const dashboardSvc = new DashboardService();
    const invoicesSummary: IDuplicateData = yield call(
      dashboardSvc.loadDuplicates.bind(
        dashboardSvc,
        selectedCustomerId,
        customerType
      )
    );
    yield put(loadDuplicatesSuccess(invoicesSummary));
  } catch (err) {
    console.error('loadDuplicatesSaga', err);
    yield put(loadDuplicatesFailure(err));
  }
}

export function* loadBilledByDaySaga(params: ILoadDashboardParams) {
  const { selectedCustomerId, billedByDayMonthDate, customerType } =
    params.payload;
  try {
    const dashboardSvc = new DashboardService();
    const billedByDayData: IBilledByDayData[] = yield call(
      dashboardSvc.loadBilledByDay.bind(
        dashboardSvc,
        selectedCustomerId,
        billedByDayMonthDate,
        customerType
      )
    );
    yield put(loadBilledByDaySuccess(billedByDayData));
  } catch (err) {
    console.error('loadBilledByDaySaga', err);
    yield put(loadBilledByDayFailure(err));
  }
}

export function* loadDuplicatesByDaySaga(params: ILoadDashboardParams) {
  const { selectedCustomerId, duplicatesByDayMonthDate, customerType } =
    params.payload;
  try {
    const dashboardSvc = new DashboardService();
    const duplicatesByDayData: IDuplicatesByDayData[] = yield call(
      dashboardSvc.loadDuplicatesByDay.bind(
        dashboardSvc,
        selectedCustomerId,
        duplicatesByDayMonthDate,
        customerType
      )
    );
    yield delay(2500);
    yield put(loadDuplicatesByDaySuccess(duplicatesByDayData));
  } catch (err) {
    console.error('loadDuplicatesByDaySaga', err);
    yield put(loadDuplicatesByDayFailure(err));
  }
}
